import { render, staticRenderFns } from "./NoteSection.vue?vue&type=template&id=4aab1cf3&scoped=true&"
import script from "./NoteSection.vue?vue&type=script&lang=js&"
export * from "./NoteSection.vue?vue&type=script&lang=js&"
import style0 from "./NoteSection.vue?vue&type=style&index=0&id=4aab1cf3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aab1cf3",
  null
  
)

export default component.exports